import { Injectable } from '@angular/core';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { Observable, of } from 'rxjs';
import { switchMap } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class CheckAuthGuard {
  constructor(private readonly oidcSecurityService: OidcSecurityService) {}

  canActivate(): Observable<boolean> {
    return this.oidcSecurityService.checkAuth().pipe(switchMap(() => of(true)));
  }

  canActivateChild() {
    return this.canActivate();
  }
}
